import appApi from '../../../../../api/app-api';
import { AssignmentFilters } from '../side-bar-filter/assignments-side-bar-filter.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const getAssignmentReportOperation = async (
  filters: AssignmentFilters,
) => {
  try {
    const response = await appApi.getAssignmentReport(filters);
    if (response.data.errCode) {
      toast.warn(displayErrorText(response.data.errCode));
      return;
    }
    return response.data.body;
  } catch (e) {
    console.error('Error fetching assignment report:', e);
    throw e;
  }
};
